import dataConfigs from '@/project/data/index.js'
import { SerializerFactory } from './serializerFactory.js'

export function registerAllSerializers() {
  SerializerFactory.register(new dataConfigs.serializers.user())
}
